import React from 'react';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import Divider from '@mui/material/Divider';
import LaunchIcon from '@mui/icons-material/Launch';
import Box from '@mui/material/Box';

const AnaTruckMobileCard = ({ data, t, isAdminOrManager, visibleOnGrid, isCicass }) => {
  return (
    <>
      {data.map((item, idx) => (
        <Paper key={idx} elevation={2} sx={{ p: 1.5, mb: 1.5, borderRadius: 2 }}>
          <Typography variant="subtitle2" fontWeight="bold" sx={{ fontSize: '0.95rem' }}>
            {item.name} ({item.licensePlate})
          </Typography>

          <Divider sx={{ my: 1, borderColor: '#ccc' }} />

          <Typography variant="body2" sx={{ fontSize: '0.85rem' }}>
            <strong>{t("Brand")}:</strong> {item.brand || '-'}
          </Typography>
          <Typography variant="body2" sx={{ fontSize: '0.85rem' }}>
            <strong>{t("Model")}:</strong> {item.model || '-'}
          </Typography>
          <Typography variant="body2" sx={{ fontSize: '0.85rem' }}>
            <strong>{t("FuelType")}:</strong> {item.fuelType || '-'}
          </Typography>

          {visibleOnGrid && (
            <>
              <Typography variant="body2" sx={{ fontSize: '0.85rem' }}>
                <strong>{t("VehicleType")}:</strong> {item.vehicleType || '-'}
              </Typography>
              <Typography variant="body2" sx={{ fontSize: '0.85rem' }}>
                <strong>{t("chassisNumber")}:</strong> {item.chassisNumber || '-'}
              </Typography>
              <Typography variant="body2" sx={{ fontSize: '0.85rem' }}>
                <strong>{t("fuel_capacity")}:</strong> {item.fuelCapacity || 0}
              </Typography>
              <Typography variant="body2" sx={{ fontSize: '0.85rem' }}>
                <strong>{t("last_maintenance_date")}:</strong> {item.lastMaintenanceDate || '-'}
              </Typography>
              <Typography variant="body2" sx={{ fontSize: '0.85rem' }}>
                <strong>{t("next_maintenance_date")}:</strong> {item.nextMaintenanceDate || '-'}
              </Typography>
              <Typography variant="body2" sx={{ fontSize: '0.85rem' }}>
                <strong>{t("insurance_details")}:</strong> {item.insuranceDetails || '-'}
              </Typography>
              <Typography variant="body2" sx={{ fontSize: '0.85rem' }}>
                <strong>{t("insurance_expiry_date")}:</strong> {item.insuranceExpiryDate || '-'}
              </Typography>
              <Typography variant="body2" sx={{ fontSize: '0.85rem' }}>
                <strong>{t("revision_date")}:</strong> {item.revisionDate || '-'}
              </Typography>
            </>
          )}

          {isCicass && (
            <Typography variant="body2" sx={{ fontSize: '0.85rem' }}>
              <strong>{t("viewOrder")}:</strong> {item.viewOrder}
            </Typography>
          )}

          {isAdminOrManager && (
            <Typography variant="body2" sx={{ fontSize: '0.85rem' }}>
              <strong>{t("notes")}:</strong> {item.notes || '-'}
            </Typography>
          )}

          {item.googleSheetLink && (
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 1 }}>
              <IconButton
                aria-label="Apri Google Sheet"
                onClick={() => window.open(item.googleSheetLink, '_blank')}
                size="small"
              >
                <LaunchIcon fontSize="small" />
              </IconButton>
            </Box>
          )}
        </Paper>
      ))}
    </>
  );
};

export default AnaTruckMobileCard;
